/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import AssessmentResultQuestion from "./AssessmentResultQuestion";
import ValueCards from "../../component/common/cards/valueCard";
import { Api } from "../../api";
import { useSearchParams } from "react-router-dom";
import Loader from "../../component/common/Loader";

const SelfAssesmentResult = ({ questionsList }) => {
  const [resultData, setResultData] = useState({});
  const [questionData, setQuestionData] = useState([]);
  const [params] = useSearchParams();
  const [loader, setLoader] = useState(false);
  const id = params.get("id");
  const fetchSelfAssesmentResult = async () => {
    try {
      setLoader(true);
      Api.getAssessmentResult(id)
        .then((response) => {
          setResultData(response?.data);
          const data =
            response?.data?.questions &&
            response?.data?.questions.map((question) => {
              return {
                questionId: question.questionId,
                title: question.questionTitle, // Renamed 'questionTitle' to 'title'
                totalResponses: question.totalResponses,
                options: question.optionCounts.map((option) => {
                  return {
                    optionId: option.optionId,
                    value: option.optionValue, // Renamed 'optionValue' to 'value'
                    count: option.count,
                    percentage: option.percentage,
                  };
                }),
              };
            });
          setQuestionData(data);
        })
        .catch((error) => {
          console.error("Error fetching SelfAssesmentResult:", error);
        })
        .finally(() => {
          setLoader(false);
        });
    } catch (error) {
      console.error("Error fetching SelfAssesmentResult:", error);
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchSelfAssesmentResult();
  }, []);
  return (
    <>
      {loader && <Loader />}
      <ValueCards resultData={resultData} />
      {questionData &&
        questionData.length > 0 &&
        questionData.map((data, index) => (
          <AssessmentResultQuestion
            questionsList={data}
            index={index}
            key={index}
          />
        ))}
    </>
  );
};

export default SelfAssesmentResult;
